import React, { useCallback } from 'react';

type FilterCountProps = {
  count: number;
  onReset: () => void;
};

const FilterCount = ({ count, onReset }: FilterCountProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    onReset();
  };

  return (
    <React.Fragment>
      <div className="filterCount">
        <a onClick={handleClick}>
          <span className="countCounter">{count}</span>
          <i className="material-icons">close</i>
        </a>
      </div>
    </React.Fragment>
  );
};

export default FilterCount;
